var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _stateSubscription, _states, _subscriptions, _updates, _workflow;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateFieldGet(receiver, privateMap) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get"); return _classApplyDescriptorGet(receiver, descriptor); }
function _classApplyDescriptorGet(receiver, descriptor) { if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }
function _classPrivateFieldSet(receiver, privateMap, value) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set"); _classApplyDescriptorSet(receiver, descriptor, value); return value; }
function _classExtractFieldDescriptor(receiver, privateMap, action) { if (!privateMap.has(receiver)) { throw new TypeError("attempted to " + action + " private field on non-instance"); } return privateMap.get(receiver); }
function _classApplyDescriptorSet(receiver, descriptor, value) { if (descriptor.set) { descriptor.set.call(receiver, value); } else { if (!descriptor.writable) { throw new TypeError("attempted to set read only private field"); } descriptor.value = value; } }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { v4 as uuid } from 'uuid';
import { Subscription, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { set } from '@ember/object';
import Service, { inject as service } from '@ember/service';
import workflow, { createState, initializeAction, ActionType, REFETCH_CARD_AFTER_MODAL_CLOSES_SCREENS } from '@banking/ui/workflows/card-settings/cancel-card';
import { updateLogger } from '@banking/ui/lib/workflow/update-logger';
import { createEmit, createSelect } from '@banking/ui/lib/workflow-ember/decorators';
import connect from '@banking/ui/lib/workflow-ember/connect';
import fetchMultipassStatus from '@banking/api/utils/multipass-status';
const SERVICE_REGISTRY_KEY = 'card-management/cancel-card-modal';
let CancelCardModalState = (_dec = service('bbfrontend/v1/checking'), _dec2 = service('bbfrontend/v1/challenge'), _dec3 = service('bb-debit/card-management-service'), (_class = (_stateSubscription = /*#__PURE__*/new WeakMap(), _states = /*#__PURE__*/new WeakMap(), _subscriptions = /*#__PURE__*/new WeakMap(), _updates = /*#__PURE__*/new WeakMap(), _workflow = /*#__PURE__*/new WeakMap(), class CancelCardModalState extends Service {
  constructor(...args) {
    super(...args);
    _classPrivateFieldInitSpec(this, _stateSubscription, {
      writable: true,
      value: null
    });
    _classPrivateFieldInitSpec(this, _states, {
      writable: true,
      value: new Subject()
    });
    _classPrivateFieldInitSpec(this, _subscriptions, {
      writable: true,
      value: new Subscription()
    });
    _classPrivateFieldInitSpec(this, _updates, {
      writable: true,
      value: new Subject()
    });
    _classPrivateFieldInitSpec(this, _workflow, {
      writable: true,
      value: void 0
    });
    _defineProperty(this, "state", createState());
    _defineProperty(this, "doneCallback", () => {});
    _initializerDefineProperty(this, "addressFrontend", _descriptor, this);
    _initializerDefineProperty(this, "applicationRouter", _descriptor2, this);
    _initializerDefineProperty(this, "bbFrontendV1CheckingService", _descriptor3, this);
    _initializerDefineProperty(this, "bbFrontendChallengeApi", _descriptor4, this);
    _initializerDefineProperty(this, "cardManagementService", _descriptor5, this);
    _initializerDefineProperty(this, "bizbankApi", _descriptor6, this);
    _initializerDefineProperty(this, "intl", _descriptor7, this);
    _initializerDefineProperty(this, "marketToasts", _descriptor8, this);
    _initializerDefineProperty(this, "multipassExternalApi", _descriptor9, this);
    _initializerDefineProperty(this, "sentry", _descriptor10, this);
    _initializerDefineProperty(this, "userInfo", _descriptor11, this);
    _classPrivateFieldSet(this, _stateSubscription, _classPrivateFieldGet(this, _states).subscribe({
      next: state => set(this, 'state', state),
      error: error => this.sentry.captureException(error)
    }));
    _classPrivateFieldGet(this, _updates).subscribe(updateLogger('Cancel Card Modal - Authorized User Card'));
    this.reset();
  }
  willDestroy() {
    this.deinitialize();
    _classPrivateFieldGet(this, _subscriptions).unsubscribe();
    super.willDestroy();
  }
  reset() {
    _classPrivateFieldGet(this, _subscriptions).unsubscribe();
    _classPrivateFieldSet(this, _subscriptions, new Subscription());
    _classPrivateFieldSet(this, _workflow, workflow(createState(), this.context));
    _classPrivateFieldGet(this, _subscriptions).add(_classPrivateFieldGet(this, _workflow).states.subscribe({
      next: next => _classPrivateFieldGet(this, _states).next(next),
      error: error => this.sentry.captureException(error)
    }));
    _classPrivateFieldGet(this, _subscriptions).add(_classPrivateFieldGet(this, _workflow).updates.subscribe(next => _classPrivateFieldGet(this, _updates).next(next)));
    _classPrivateFieldGet(this, _subscriptions).add(_classPrivateFieldGet(this, _workflow).updates.pipe(filter(([[_, next], action]) => action.type === ActionType.UserClickCloseModal && REFETCH_CARD_AFTER_MODAL_CLOSES_SCREENS.includes(next.navigation.current))).subscribe(() => this.doneCallback()));
  }
  emit(action) {
    _classPrivateFieldGet(this, _workflow).emit(action);
  }
  openModal(balanceId, card, cardCustomization, cancellationType, unitToken, doneCallback = () => {}) {
    _classPrivateFieldGet(this, _workflow).emit(initializeAction(balanceId, card, cardCustomization, cancellationType, unitToken));
    this.doneCallback = doneCallback;
  }
  get states() {
    return _classPrivateFieldGet(this, _states).asObservable();
  }
  deinitialize() {
    _classPrivateFieldGet(this, _subscriptions).unsubscribe();
    _classPrivateFieldGet(this, _stateSubscription)?.unsubscribe();
  }
  get context() {
    return {
      applicationRouter: this.applicationRouter,
      createCard: this.cardManagementService.client.createCard.bind(this.cardManagementService.client),
      createCardCustomization: this.bizbankApi.client.createCardCustomization.bind(this.bizbankApi.client),
      deactivateAccount: this.bbFrontendV1CheckingService.client.deactivateChecking.bind(this.bbFrontendV1CheckingService.client),
      intl: this.intl,
      fetchMultipassStatus,
      listCards: this.cardManagementService.client.listCards.bind(this.cardManagementService.client),
      lookupCountryAddressData: () => this.addressFrontend.lookupCountryAddressData(),
      marketToasts: this.marketToasts,
      multipass: this.multipassExternalApi.client,
      provideFeedback: this.bizbankApi.client.provideFeedback.bind(this.bizbankApi.client),
      terminateCard: this.cardManagementService.client.terminateCard.bind(this.cardManagementService.client),
      sentry: this.sentry,
      startChallenge: this.bbFrontendChallengeApi.client.startChallenge.bind(this.bbFrontendChallengeApi.client),
      userInfo: this.userInfo,
      uuid,
      validateAddress: this.bizbankApi.client.validateAddress.bind(this.bizbankApi.client)
    };
  }
}), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "addressFrontend", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "applicationRouter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "bbFrontendV1CheckingService", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "bbFrontendChallengeApi", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "cardManagementService", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "bizbankApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "marketToasts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "multipassExternalApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
export { CancelCardModalState as default };
export const select = createSelect(SERVICE_REGISTRY_KEY);
export const emit = createEmit(SERVICE_REGISTRY_KEY);
export const workflowComponent = connect(SERVICE_REGISTRY_KEY);